export default class Customer {

    constructor(jsonResponse) {

        this.registrationId = jsonResponse["registration-id"];
        this.dob = jsonResponse["dob"];
        this.firstName = jsonResponse["first-name"];
        this.lastName = jsonResponse["last-name"];
        this.gender = jsonResponse["gender"];
        this.idNumber = jsonResponse["id-number"];
        this.idType = jsonResponse["id-type"];
        this.countryCode = jsonResponse["country-code"];
        this.msisdnValue = jsonResponse["msisdn"];
        this.approvalStatus = jsonResponse["approval-status"];
        this.countryName = jsonResponse["country-name"];

        this.fullName = this.firstName + " " + this.lastName;
    }

}